// Static registry of Claude Course lessons.
// The only authored data per lesson; everything else (body, exercise, rubric,
// test cases) is generated by Claude on first visit and cached in Firestore.

export const CLAUDE_COURSE_LESSONS = [
    { lessonID: "CC401", route: "CC_M1_L1", title: "What It Means to Use Claude Like a Developer", type: "concept" },
    { lessonID: "CC402", route: "CC_M1_L2", title: "The Anatomy of a Good Developer Prompt", type: "concept" },
    { lessonID: "CC403", route: "CC_M1_L3", title: "Asking Claude to Explain Code", type: "concept" },
    { lessonID: "CC404", route: "CC_M1_L4", title: "Asking Claude to Generate Simple Code", type: "code", language: "python" },
    { lessonID: "CC405", route: "CC_M1_L5", title: "Giving Claude Clear Requirements", type: "code", language: "python" },
    { lessonID: "CC406", route: "CC_M1_L6", title: "Debugging With Claude", type: "code", language: "python" },
    { lessonID: "CC407", route: "CC_M1_L7", title: "Asking Claude for the Smallest Fix", type: "code", language: "python" },
    { lessonID: "CC408", route: "CC_M1_L8", title: "Reviewing AI-Generated Code", type: "concept" },
    { lessonID: "CC409", route: "CC_M1_L9", title: "Asking Claude to Improve Code", type: "code", language: "python" },
    { lessonID: "CC410", route: "CC_M1_L10", title: "Planning a Project With Claude Before Coding", type: "concept" },
    { lessonID: "CC411", route: "CC_M1_L11", title: "Building One Feature at a Time With Claude", type: "code", language: "python" },
    { lessonID: "CC412", route: "CC_M1_L12", title: "Using Claude to Understand Errors", type: "concept" },
    { lessonID: "CC413", route: "CC_M1_L13", title: "Using Claude Without Cheating Yourself", type: "concept" },
    { lessonID: "CC414", route: "CC_M1_L14", title: "Creating Reusable Prompt Templates", type: "concept" },
    { lessonID: "CC415", route: "CC_M1_L15", title: "Mini Project: Build With Claude", type: "code", language: "python" },
];

export const getLessonMetaByRoute = (route) =>
    CLAUDE_COURSE_LESSONS.find((l) => l.route === route);

/**
 * Given a route, return the route of the next lesson in the registry, or null
 * if this is the last one.
 */
export const getNextLessonRoute = (currentRoute) => {
    const idx = CLAUDE_COURSE_LESSONS.findIndex((l) => l.route === currentRoute);
    if (idx === -1 || idx === CLAUDE_COURSE_LESSONS.length - 1) return null;
    return CLAUDE_COURSE_LESSONS[idx + 1].route;
};
